import { render, staticRenderFns } from "./PhonePreviewLayout.vue?vue&type=template&id=1ca295ae&scoped=true&"
import script from "./PhonePreviewLayout.vue?vue&type=script&lang=js&"
export * from "./PhonePreviewLayout.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreviewLayout.vue?vue&type=style&index=0&id=1ca295ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca295ae",
  null
  
)

export default component.exports